<template>
  <div :class="[isCheckbox ? 'col-lg-12' : 'col-lg-9']">

    <feature-input-manager :stepListFeatureComponent="stepListFeatureComponent" :listFeatureComponent="listFeatureComponent" :featureProduct="featureProduct" :product="product"/>

    <feature-item-extra v-if="!isCheckbox && stepManagerGeneralProps.accessToFeatureExtra" :product="product"
                        :key="generateRandomString()" :product-feature="featureProduct"/>
  </div>
</template>

<script>
import CheckboxItemConfig from "./FeatureInput/CheckboxInput/CheckboxItemConfig.vue";
import FeatureItemExtra from "./FeatureItemExtra.vue";
import {generateRandomString} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {unFilteredFeatureTypes} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Feature'
import FeatureInputManager from "./FeatureInput/FeatureInputManager.vue";

export default {
  name: "NormalItemConfig",
  methods: {generateRandomString},
  components: {FeatureInputManager, FeatureItemExtra, CheckboxItemConfig},
  props: {
    featureProduct: {},
    product: {},
    stepListFeatureComponent: {
      default: '',
    },
    listFeatureComponent:{
      default: '',
    }
  },
  data() {
    return {
      unFilteredFeatureTypes
    }
  },
  computed: {
    featureType() {
      return this.isCheckbox ? 'checkbox' : this.featureProduct.feature.type
    },
    featureAttributes() {
      return this.featureProduct.feature.feature_attributes
    },
    isCheckbox() {
      return Array.isArray(this.featureProduct)
    },
    stepManagerGeneralProps() {
      return this.product.props
    }
  },
}
</script>

<style scoped>

</style>